export default [
  {
    path: '/demo-chart',
    name: 'demoChart',
    component: () => import(/* webpackChunkName:'demo'*/ '@/views/demo/DemoChart.vue'),
    meta: {
      anonymous: true,
    },
  },
  {
    path: '/demo-control',
    name: 'demoControl',
    component: () => import(/* webpackChunkName:'demo'*/ '@/views/demo/DemoControl.vue'),
    meta: {
      anonymous: true,
    },
  },
  {
    path: '/demo-combobox',
    name: 'demoCombobox',
    component: () => import(/* webpackChunkName:'demo'*/ '@/views/demo/DemoCombobox.vue'),
    meta: {
      anonymous: true,
    },
  },
  {
    path: '/publishing',
    name: 'publishing',
    component: () => import(/* webpackChunkName:'demo'*/ '@/views/demo/Publishing.vue'),
    meta: {
      anonymous: true,
    },
  },
  {
    path: '/demo-grid-view-normal',
    name: 'demoGridViewNormal',
    component: () => import(/* webpackChunkName:'demo'*/ '@/views/demo/DemoGridViewNormal.vue'),
    meta: {
      anonymous: true,
    },
  },
  {
    path: '/demo-grid-tree-voucher',
    name: 'demoGridTreeVoucher',
    component: () => import(/* webpackChunkName:'demo'*/ '@/views/demo/DemoGridTreeVoucher.vue'),
    meta: {
      anonymous: true,
    },
  },
  {
    path: '/demo-grid-tree',
    name: 'demoGridTree',
    component: () => import(/* webpackChunkName:'demo'*/ '@/views/demo/DemoGridTree.vue'),
    meta: {
      anonymous: true,
    },
  },
  {
    path: '/demo-grid-edit',
    name: 'demoGridEdit',
    component: () => import(/* webpackChunkName:'demo'*/ '@/views/demo/DemoGridEdit.vue'),
    meta: {
      anonymous: true,
    },
  },
  {
    path: '/demo-combobox',
    name: 'demoCombobox',
    component: () => import(/* webpackChunkName:'demo'*/ '@/views/demo/DemoCombobox.vue'),
    meta: {
      anonymous: true,
    },
  },
  {
    path: '/demo-grid-view-normal',
    name: 'demoGridViewNormal',
    component: () => import(/* webpackChunkName:'demo'*/ '@/views/demo/DemoGridViewNormal.vue'),
    meta: {
      anonymous: true,
    },
  },
  {
    path: '/demo-grid-edit',
    name: 'demoGridEdit',
    component: () => import(/* webpackChunkName:'demo'*/ '@/views/demo/DemoGridEdit.vue'),
    meta: {
      anonymous: true,
    },
  },
  {
    path: '/demo-form',
    name: 'demoForm',
    component: () => import(/* webpackChunkName:'demo'*/ '@/views/demo/DemoForm.vue'),
    meta: {
      anonymous: true,
    },
  },
  {
    path: '/demo-message',
    name: 'demoMessage',
    component: () => import(/* webpackChunkName:'demo'*/ '@/views/demo/DemoMessage.vue'),
    meta: {
      anonymous: true,
    },
  },
  {
    path: '/demo-toast',
    name: 'demoToast',
    component: () => import(/* webpackChunkName:'demo'*/ '@/views/demo/DemoToast.vue'),
    meta: {
      anonymous: true,
    },
  },
  {
    path: '/account-combo',
    name: 'accountCombo',
    component: () => import(/* webpackChunkName:'demo'*/ '@/views/dictionary/account/AccountCombobox.vue'),
    meta: {},
  },
  {
    path: '/account-editor',
    name: 'accountEditor',
    component: () => import(/* webpackChunkName:'demo'*/ '@/views/dictionary/account/AccountListEditor.vue'),
    meta: {},
  },
  {
    path: '/demo-super',
    name: 'demoSuper',
    component: () => import(/* webpackChunkName:'demo'*/ '@/views/demo/DemoSuper.vue'),
    meta: {
      anonymous: true,
    },
  },
];
